//#region src/variants/variants_list_item.js
var variants_list_item_default = { default: {
	props: { navigationType: { initialValue: "tab" } },
	slots: { default: { initialValue: "Default List Item" } }
} };
//#endregion
export { variants_list_item_default as default };

//# sourceMappingURL=variants_list_item.js.map